module.exports = __webpack_public_path__ + "files/d5057c593084354e62842af678385d91.png";